import { useTranslation } from 'react-i18next';

import type { ImageToVideoModel } from '../../../hooks/useImageToVideoActions';
import SectionCard from '../../common/sectionCard';
import { IMAGE_TO_VIDEO_SAMPLE_IMAGES } from '../../../constants/imageToVideoSampleMedia';

type ModeSectionProps = {
  model: ImageToVideoModel;
};

const ModeSection = ({ model }: ModeSectionProps) => {
  const { t } = useTranslation();
  const { style, actions } = model;

  const walkthroughImage = IMAGE_TO_VIDEO_SAMPLE_IMAGES[0];
  const furnishImage = IMAGE_TO_VIDEO_SAMPLE_IMAGES[1] ?? IMAGE_TO_VIDEO_SAMPLE_IMAGES[0];

  const renderModeCard = (
    mode: 'walkthrough' | 'furnish_estate',
    imageUrl: string,
    options?: { disabled?: boolean }
  ) => {
    const isActive = style.mode === mode;
    const label = mode === 'walkthrough' ? t('mode-walk-through') : t('mode-furnish-estate');
    const disabled = options?.disabled;

    return (
      <button
        key={mode}
        type="button"
        onClick={() => {
          actions.onModeChange(mode);
        }}
        disabled={disabled}
        className="flex-1 rounded-md bg-white p-1 shadow-sm disabled:cursor-not-allowed disabled:opacity-50"
      >
        <div className="h-20 w-full overflow-hidden rounded-sm bg-gray-100">
          <img src={imageUrl} alt={label} className="h-full w-full object-cover" />
        </div>
        <div className="mt-2 text-center text-xs font-semibold">
          <span className={isActive ? 'text-primary-light' : 'text-text-secondary'}>{label}</span>
        </div>
      </button>
    );
  };

  return (
    <SectionCard title={t('mode')}>
      <div className="flex gap-2">
        {renderModeCard('walkthrough', walkthroughImage.url)}
        {renderModeCard('furnish_estate', furnishImage.url, { disabled: true })}
      </div>
    </SectionCard>
  );
};

export default ModeSection;
